import { UserMenu as Menu } from './menu/UserMenu';

export const User = {
  Menu,
};
